const verificationbadge = "InstagramVerificationBadge.svg"
const calendar = "calendar.svg"
const vehicleicon = "vehicleicon.svg"
const avgspeed = "avg speed.svg"
const downArrow = "down arrow.svg"
const dashboard = "dashboard.svg"
const milage = "milage.svg"
const speed = "speed.svg"
const previous = "previous.svg"
const next = "next.svg"
const client = "client.svg"
const map = "map.svg"
const check = "check.svg"
const cancelButton = "cancel.svg"
const eyeopened = "eye-opened.svg"
const eyeclosed = "eye-closed.svg"
const vendor = "vendor.svg"
const mylocation = "my-location.svg"
const checkmarkgreen = "checkmarkgreen.svg"
const booking = "booking.svg"
const trips = "trips.svg"
const edit = "edit.svg"
const Plus = "plus.svg"
const Upload = "upload.svg"
const document = "doc.svg"
const truck = "truck.svg"
const container = "container.svg"
const fuel = "fuel.svg"
const driver = "driver.svg"
const police = "police.svg"
const toll = "toll.svg"
const others = "others.svg"
const backArrow = "backArrow.svg"
const nextArrow = "nextArrow.svg"
const download = "download.svg"
const filter = "filter.svg"
const search = "search.svg"
const notification = "notification.svg"
const vehicle = "vechile.svg"
const profile = "profile.svg"
const coin = "coins.svg"
const placeMareker = "Place Marker.svg"
const minspeed = "min speed.svg"
const maxspeed = "max speed.svg"
const assignvehicle="assignvehicle.svg"
const assignsurveyor="assignsurveyor.svg"
const driverImg = "assigndriver.svg"
const routes = "routes.svg"
const employee = "employee.svg"
const vehicles = "vehicles.svg"
const vehiclecontainer = "vehiclecontainer.svg"
const vehicledriver= "vehicledriver.svg"
const vehicleTruck = "vehicleTruck.svg"
export {
  routes, employee,
  dashboard,
  driverImg,
  vendor,
  vehicles,
  assignvehicle,
  assignsurveyor,
  vehiclecontainer,
  vehicledriver,
  vehicleTruck,
  minspeed,
  maxspeed,
  avgspeed,
  profile,
  placeMareker,
  client,
  check,
  vehicleicon,
  backArrow,
  notification,
  nextArrow,
  download,
  filter,
  search,
  milage,
  map,
  edit,
  speed,
  checkmarkgreen,
  calendar,
  mylocation,
  verificationbadge,
  eyeopened,
  eyeclosed,
  cancelButton,
  Upload,
  Plus,
  document,
  truck,
  container,
  vehicle,
  trips,
  booking,
  fuel,
  driver,
  police,
  toll,
  coin,
  others,
  downArrow,
  previous,
  next,
};